import { gql } from '@apollo/client';

export const GetMyAccessTokensQueryName = 'GetMyAccessTokens';

export const GET_MY_ACCESS_TOKENS_QUERY = gql`
  query ${GetMyAccessTokensQueryName} {
    getMyAccessTokens {
      id,
      name,
      createdAt,
      expiresAt,
      lastUsedAt,
      token
    }
  }
`;
